import React from "react";
import { ReactComponent as YaAuth} from './static/yandex.svg';
import { ReactComponent as VkOneTap} from './static/VKOneTap.svg';
import './AuthVariants.css'
import request from "../../../Requests/requests";

interface AuthVariantsProps {
    onClickFunction?: Function
    isPrivacyPolicy: boolean
}

export default function AuthVariants({ onClickFunction, isPrivacyPolicy=false }: AuthVariantsProps) {
    // let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no`;
    const prodHidden = process.env.REACT_APP_IS_DEV === 'true';
    const handleclick = (typeAuth: string) => {
        onClickFunction && onClickFunction()
        if (!isPrivacyPolicy) {
            return
        }
        request.get(`${typeAuth}`)
        .then((response) => {
            if (typeAuth === '/auth/vk/login') {
                localStorage.setItem('codeVerifier', response.data.codeVerifier)
                window.open(response.data.authUrl, 'Auth')            
            } else if (typeAuth === '/auth/yandex/login') {
                window.open(response.data, 'Auth')               
            }
        })        
    }

    return (
        <div className="AuthVariants__container">
            <p className="AuthVarinats__descr">или</p>
                <div className="AuthVariants__btn-group">
                    {
                        prodHidden && 
                        <button id="vkAuth" className="vkAuth" onClick={() => handleclick('/auth/vk/login')}>
                            <VkOneTap />            
                        </button>
                    }
                    <button id="YaAuth" className="YaAuth" onClick={() => handleclick('/auth/yandex/login')}>
                        <YaAuth/>            
                    </button>
                </div>
        </div>
    )
}